import { UAE_CODE } from ".";

export const endpoints = {
  baseUrl: "http://conv.rakbankonline.ae/quickapply",
  appConfigUri: "/onboarding/config/accounts",
  createProspectUri: "/api/v1/products/stp-accounts/prospects",
  getProspectUri: "/api/v1/products/stp-accounts/prospects/:prospectId",
  getWtmProspectUri: "/api/v1/products/stp-accounts/wtm/prospects/:prospectId",
  updateProspectUri: "/api/v1/products/stp-accounts/prospects/:prospectId",
  updateWtmProspectUri: "/api/v1/products/stp-accounts/wtm/prospects/:prospectId",
  getProspectDocumentsUri: "/api/v1/products/stp-accounts/prospects/:prospectId/documents",
  /**TODO: To be pointing 2.0 api */
  uploadDocumentUri: "/rest/v1/banks/RAK/prospectId/:prospectId/documents",
  /**TODO: To be pointing 2.0 api */
  reuploadDocumentUri: "/rest/v1/banks/RAK/prospectId/:prospectId/documents",
  searchProspectUri: "/api/v1/products/stp-accounts/prospects/search",
  /**TODO: To be pointing 2.0 exp-api */
  getDocumentByIdUri: "/rest/v1/banks/RAK/prospectId/:prospectId/documents/:documentKey",
  screenProspectUri: "/onboarding/products/accounts/prospects/:prospectId/screening",
  otpUri: "/api/v1/stp-accounts/otp",
  /**TODO: To be pointing 2.0 exp-api */
  authenticateUserUri: "/api/v1/users/authenticate",
  logoutUri: "/api/v1/logout",
  /**TODO: To be pointing 2.0 exp-api */
  docUploaderUri: "/api/v1/banks/RAK/prospects/:prospectId/documents",
  /**TODO: To be pointing 2.0 exp-api */
  createInviteUri: "/api/v1/agent/createInvite",
  prospectDecisions: "/api/v1/products/stp-accounts/prospects/:prospectId/decisions",
  prospectWtmDecisions: "/api/v1/products/stp-accounts/wtm/prospects/:prospectId/decisions",
  createKYCTransactionUri: "/api/v1/products/sme-accounts/efr/transactions",
  createWtmKYCTransactionUri: "/api/v1/products/sme-accounts/wtm/efr/transactions",
  //document upload DEH
  documentUploaderToken: "/api/v1/onboarding/document/oauth2/token",
  generateWebToMobileQRCode: "/api/v1/products/stp-accounts/prospects/:prospectId/webToMobile",
  refreshWebToMobileQRCode:
    "/api/v1/products/stp-accounts/prospects/:prospectId/webToMobile/:webToMobileRefId/refresh",
  wtmSyncSession: "/api/v1/products/stp-accounts/webToMobile/auth/token",
  wtmStatusUpdate:
    "/api/v1/products/stp-accounts/prospects/:prospectId/webToMobile/:webToMobileRefId",
  cpfSendEmailUrl: "/api/v1/cpf/product-config/subproducts/kfs-acknowledgement",
  cpfCustomerConsentUrl: "/api/v1/cpf/consent/customers",
  sendEFRInvite: "/api/v1/products/stp-accounts/prospects/:prospectId/efrlink/actions",
  updateProspectByShareholderUri:
    "/api/v1/products/stp-accounts/prospects/:prospectId/signatories/:signatoryId",
  updateWtmProspectByShareholderUri:
    "/api/v1/products/stp-accounts/wtm/prospects/:prospectId/signatories/:signatoryId",
  postAuthToken: "/api/v1/onboarding/post-login/oauth2/token"
};

export const prospect = {
  applicantInfo: {
    fullName: "",
    email: "",
    countryCode: UAE_CODE,
    mobileNo: ""
  },
  generalInfo: {
    prospectId: "",
    cifId: "",
    customerType: "",
    dsaId: "",
    groupId: "",
    groupName: "",
    rmCode: "",
    accountManagerId: "",
    isPoliticallyExposed: ""
  },
  applicationInfo: {
    viewId: "",
    islamicBanking: false,
    accountType: "",
    rakValuePackage: "",
    leadNumber: "",
    riskScore: "0.0",
    srNumber: "",
    channelId: "",
    channelType: "",
    createdDate: "",
    lastModifiedDate: "",
    createdBy: "",
    lastModifiedBy: "",
    actionType: "",
    saveType: "",
    tncAgreed: false,
    declaration: false
  },
  accountInfo: [
    {
      branchId: "",
      accountType: "",
      accountSubType: "",
      accountNo: "",
      accountCurrencies: [],
      accountCurrency: "",
      accountPurpose: "",
      debitCardApplied: false,
      chequeBookApplied: false,
      eStatements: false,
      mailStatements: false,
      receiveInterest: false,
      deliverByCourier: false
    }
  ],
  organizationInfo: {
    screeningInfo: {
      statusOverAll: "",
      screeningResults: []
    },
    branchCity: "",
    branchID: "",
    countryOfIncorporation: "",
    companyName: "",
    shortName: "",
    dateOfIncorporation: null,
    numberOfEmployees: 0,
    licenseType: "",
    licenseTypeOther: "",
    licenseIssuingAuthority: "",
    licenseNumber: "",
    licenseIssueDate: null,
    licenseExpiryDate: "",
    vatRegistrationNumber: "",
    addressInfo: [
      {
        typeOfAddress: "",
        officeAddressDifferent: "",
        addressDetails: [
          {
            addressFieldDesc: "",
            preferredAddress: "",
            addressLine1: "",
            addressLine2: "",
            addressLine3: "",
            addressLine4: "",
            poBox: "",
            emirateCity: "",
            country: "United Arab Emirates",
            typeOfSpaceOccupied: {
              spaceType: "",
              others: ""
            },
            officeAddrsLine1: "",
            officeAddrsPoBox: "",
            officeAddrsEmirateCity: "",
            officeAddrsCountry: "United Arab Emirates",
            preferredMailingAddrs: "",
            isDontSameAsRegisteredAddress: false
          }
        ]
      }
    ],
    contactDetails: {
      primaryMobileNo: "",
      primaryMobCountryCode: UAE_CODE,
      primaryEmail: "",
      primaryPhoneNo: "",
      primaryPhoneCountryCode: UAE_CODE,
      fax: "",
      faxCountryCode: "",
      secondaryPhoneNo: "",
      secondaryPhoneCountryCode: "",
      secondaryMobileNo: "",
      secondaryMobileCountryCode: "",
      secondaryEmail: "",
      website: ""
    },
    contactDetailsForTxnReconfirming: [
      {
        TxnReconfirmingfullname: "",
        primaryMobileNo: "",
        primaryMobCountryCode: "",
        primaryPhoneNo: "",
        primaryPhoneCountryCode: ""
      }
    ]
  },
  orgKYCDetails: {
    businessUnit: "",
    constitutionType: "",
    companyCategory: "",
    annualFinTurnoverAmtInAED: "",
    yearsInBusiness: 0,
    topCustomers: [
      {
        name: "",
        country: ""
      }
    ],
    topSuppliers: [
      {
        name: "",
        country: ""
      }
    ],
    topOriginGoodsCountries: [""],
    industryMultiSelect: [
      {
        industry: [""],
        subCategory: [""]
      }
    ],
    anticipatedTransactionsDetails: {
      totalMonthlyCashCreditsAED: {
        amountInFigures: "",
        inPercent: 0
      },
      totalMonthlyNonCashCreditsAED: {
        amountInFigures: "",
        inPercent: 0
      },
      totalMonthlyCreditsAED: "",
      maxAmtSingleTxnCashAED: "",
      maxAmtSingleTxnNonCashAED: ""
    },
    otherBankingRelationshipsInfo: {
      otherBankingRelationshipsExist: false,
      otherBankDetails: [
        {
          bankName: ""
        }
      ]
    },
    otherEntitiesInUAE: false,
    entitiesInUAE: [
      {
        companyName: "",
        emirate: "",
        tradeLicenseNo: ""
      }
    ],
    otherEntitiesOutsideUAE: false,
    entitiesOutsideUAE: [
      {
        companyName: "",
        country: ""
      }
    ],
    isDontHaveSuppliersYet: false,
    isDontTradeGoodsYet: false
  },
  signatoryInfo: [
    {
      screeningInfo: {
        statusOverAll: "",
        screeningResults: [
          {
            screeningType: "",
            screeningStatus: "",
            screeningFlag: "",
            screeningNotes: "",
            screeningReason: "",
            reasonNotes: "",
            reasonCode: "",
            reasonStatus: ""
          }
        ]
      },
      salutation: "",
      signatoryId: "",
      firstName: "",
      middleName: "",
      lastName: "",
      shortName: "",
      fullName: "",
      gender: "",
      maritalStatus: "",
      maritalStatusOthers: "",
      occupation: "",
      mothersMaidenName: "",
      numberOfDependants: 0,
      highestEducationAttained: "",
      employmentStatus: "",
      kycVerified: false,
      kycDetails: {
        isShareholderACompany: false,
        salutation: "",
        shareholderPOASignatoryName: "",
        isSignatory: false,
        isShareholder: false,
        shareHoldingPercentage: 0,
        dateOfBirth: "",
        dualCitizenship: false,
        dualCitizenshipCountry: [""],
        residenceCountry: "",
        isUAEResident: false,
        passportDetails: [
          {
            passportNumber: "",
            passportExpiryDate: "",
            country: "",
            diplomatPassport: false,
            hasAnotherCitizenship: false
          }
        ],
        emirateIdDetails: {
          eidNumber: "",
          eidExpiryDt: ""
        },
        selfGovtPosition: "",
        relativeGovtPosition: "",
        isPEP: false,
        qualification: "",
        experienceInYrs: "",
        sourceOfWealth: [
          {
            wealthType: "",
            others: ""
          }
        ]
      },
      contactDetails: {
        primaryMobileNo: "",
        primaryMobCountryCode: UAE_CODE,
        primaryHomeCountryNo: "",
        primaryHomeCountryCode: UAE_CODE,
        primaryEmail: "",
        primaryPhoneNo: "",
        primaryPhoneCountryCode: UAE_CODE,
        fax: "",
        faxCountryCode: "",
        secondaryPhoneNo: "",
        secondaryPhoneCountryCode: "",
        secondaryMobileNo: "",
        secondaryMobileCountryCode: "",
        secondaryEmail: "",
        website: ""
      },
      employmentDetails: {
        employmentType: "",
        otherEmploymentType: "",
        designation: "",
        empNo: "",
        department: "",
        employerName: "",
        occupation: "",
        totalExperienceYrs: "",
        employmentStartDate: "",
        isPersonWorkAtCompany: false
      },
      sameAsCompanyAddress: false,
      addressInfo: [
        {
          typeOfAddress: "",
          addressDetails: [
            {
              addressFieldDesc: "",
              preferredAddress: "",
              addressLine1: "",
              addressLine2: "",
              addressLine3: "",
              addressLine4: "",
              poBox: "",
              emirateCity: "",
              country: "United Arab Emirates"
            }
          ]
        }
      ],
      accountSigningInfo: {
        accountSigningType: "",
        accountSigningInstn: "",
        authorityType: ""
      },
      debitCardInfo: {
        issueDebitCard: false,
        authSignatoryDetails: {
          fullNameOnPassport: "",
          nameOnDebitCard: ""
        }
      }
    }
  ],
  channelServicesInfo: {
    mobileInstructions: false,
    marketingSMS: false,
    doNotDisturbHours: "",
    weeklyBalanceNotification: "",
    monthlyBalanceNotification: 0
  },
  documents: {
    companyDocuments: [],
    stakeholdersDocuments: null,
    otherDocuments: []
  },
  kycAnnexure: {
    workItemNumber: "",
    companyName: "",
    sourcingCode: "",
    companyCifId: 0,
    retailCifId: 0,
    leadNumber: "",
    skillBasedCategory: "",
    signatoryName: "",
    businessModel: "",
    ownerAdditionalInfo: "",
    signatoryDetails: [
      {
        signatoryName: "",
        education: "",
        backgroundInfo: ""
      }
    ],
    generalRemarksRM: "",
    generalRemarksRO: "",
    verificationRemarksRM: "",
    audioVideoKycVerification: "",
    verificationDetails: [
      {
        kycVerificationDate: "",
        kycVerificationTime: "",
        verificationConductedBy: "",
        verificationStatus: "",
        verificationRemarks: ""
      }
    ],
    isUltimateBeneficiary: "",
    bankDetails: [
      {
        bankName: "",
        isStatementAvailable: "",
        bankStatementRemark: "",
        bankStatementFrom: "",
        bankStatementTo: ""
      }
    ],
    antiMoneyLaundering: "",
    poaCountry: [],
    riskIndustries: [],
    clientDealingCountry: [],
    signatoryEIDinfo: "",
    isVisitConducted: "",
    visitDetails: [
      {
        kycVisitDate: "",
        kycVisitTime: "",
        visitConductedBy: "",
        visitConductedAt: "",
        noticeToCounterfeit: ""
      }
    ],
    signatoryEIDinfoRemarks: "",
    roName: "",
    roEmployeeId: "",
    kycVerificationLocation: "",
    kycVerificationotherLocation: ""
  },
  prospectStatusInfo: {
    statusType: "",
    statusCode: "",
    statusFlag: "",
    statusNotes: "",
    statusReason: "",
    statusOverAll: "",
    reasonNotes: "",
    reasonCode: "",
    reasonStatus: ""
  },
  freeFieldsInfo: {
    freeField1: "",
    freeField2: "",
    freeField3: "",
    freeField4: "",
    freeField5: ""
  }
};

// each page based payload has to be added based no the viewId
export const pageProspectPaylodMap = {
  "/CompanyInfo": [
    "applicantInfo",
    "organizationInfo",
    "applicationInfo",
    "documents",
    "accordionsStatus",
    "userJourneyType"
  ],
  "/StakeholdersInfo": ["signatoryInfo", "userJourneyType"],
  "/StakeholdersInfoPreview": ["signatoryInfo"],
  "/ConsentInfo": ["signatoryInfo", "userJourneyType"],
  "/AdditionalInfo": ["accordionsStatus"],
  "/CompanyAdditionalInfo": ["companyAdditionalInfo", "documents", "accordionsStatus"],
  "/StakeholdersAdditionalInfo": ["signatoryInfo", "documents", "accordionsStatus"],
  "/AccountInfo": [
    "applicantInfo",
    "accountInfo",
    "signatoryInfo",
    "channelServicesInfo",
    "applicationInfo",
    "kycAnnexure",
    "documents"
  ],
  "/AdditionalData": ["documents", "additionalDataForBPM"],
  "/PartnershipDetailsInfo": ["partnersDetailInfo"],
  "/PartnerDetailsInfo": ["signatoryInfo", "documents", "sid"],
  "/PartnershipSummaryInfo": ["signatoryInfo", "sid"],
  "/SubmitApplication": ["applicantInfo"]
};
